// ets_tracing: off
import { getApplyConfig } from "../../HKT/index.mjs";
export const DecoderURI = "DecoderURI";
export const decoderApplyConfig = /*#__PURE__*/getApplyConfig(DecoderURI);
export class DecoderType {
  constructor(decoder) {
    this.decoder = decoder;
    this.childs = {};
  }

  setChilds(childs) {
    this.childs = childs;
    return this;
  }

  getChilds() {
    return this.childs;
  }

  at(k) {
    return this.childs[k];
  }

}
//# sourceMappingURL=index.mjs.map